import Message, { ChatMessage } from '@/widgets/v2/AI/Chat/Message'

interface Props {
  messages: ChatMessage[]
  isHelenSandbox?: boolean
}

const Thread = (props: Props): JSX.Element => {
  return (
    <>
      {props.messages.map((message, index) => (
        <Message
          key={index}
          message={message}
          showDivider={index < props.messages.length - 1}
          isLastMessage={index === props.messages.length - 1}
          isHelenSandbox={props.isHelenSandbox}
        />
      ))}
    </>
  )
}

export default Thread
